__turbopack_context__.v({
  "placeholder": "Checkbox-module-scss-module__uFrY0G__placeholder",
  "sub-label": "Checkbox-module-scss-module__uFrY0G__sub-label",
});
